import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { SearchProposalsListViewItem } from "@coworker/apprestructured/src/scan-and-search/components/searchResults/search-proposals/SearchProposalsListViewItem/SearchProposalsListViewItem";

interface SearchProposalsListViewProps {
  searchProposals: string[];
  handleProposalClick: (proposal: string) => void;
}

export const SearchProposalsListView = ({
  searchProposals,
  handleProposalClick,
}: SearchProposalsListViewProps) => {
  return (
    <FixaListView id={"search-proposals-list-view"} size="small">
      {searchProposals.map((proposal: string, index: number) => (
        <SearchProposalsListViewItem
          key={`${proposal}-${index}`}
          proposal={proposal}
          onProposalClick={handleProposalClick}
        />
      ))}
    </FixaListView>
  );
};
